// Картата на един персонален отчет на телефон. Общата транспозиция „ред на
// колона" би направила от осем колони карта от осем реда — тук първият ред
// носи това, което човек търси: чий е отчетът и за колко е.

import { useTranslation } from "react-i18next";

import { fmtEuro } from "../../../../utils/currency";
import { EM_DASH, parseDecimal } from "../../../../components/dataTable";
import type { Report } from "../../../../api/reports";
import { formatWorkDay, isZeroAmount } from "./personalReportsMath";

type Props = {
  report: Report;
  /** Има ли в периода платено извън в брой и карта — както в таблицата. */
  showOther: boolean;
};

export const PersonalReportMobileCard = ({ report, showOther }: Props) => {
  const { t } = useTranslation();
  const other = parseDecimal(report.other_amount);

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-2">
        <span className="shrink-0 font-pos-mono text-[13px] font-bold tabular-nums text-brand-deep-ink">
          {`#${report.report_number}`}
        </span>
        <span className="min-w-0 flex-1 truncate text-[15px] font-bold text-ink">
          {report.user_name || EM_DASH}
        </span>
        <span className="font-pos-mono text-[15px] font-bold tabular-nums text-ink">
          {fmtEuro(parseDecimal(report.total_amount))}
        </span>
      </div>

      <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[12px] font-medium text-muted">
        <span className="font-pos-mono tabular-nums">
          {formatWorkDay(report.report_date)}
        </span>
        <span aria-hidden>·</span>
        <span>
          {`${report.total_bills_count} ${t("reportsPage.bills").toLowerCase()}`}
        </span>
      </div>

      <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[12px] font-medium text-soft">
        <span className="font-pos-mono tabular-nums">
          {`${t("reportsPage.cashAmount")} ${fmtEuro(parseDecimal(report.cash_amount))}`}
        </span>
        <span aria-hidden>·</span>
        <span className="font-pos-mono tabular-nums">
          {`${t("reportsPage.cardAmount")} ${fmtEuro(parseDecimal(report.card_amount))}`}
        </span>
        {showOther && !isZeroAmount(other) ? (
          <>
            <span aria-hidden>·</span>
            <span className="font-pos-mono tabular-nums">
              {`${t("reportsPage.dailyOther")} ${fmtEuro(other)}`}
            </span>
          </>
        ) : null}
      </div>
    </div>
  );
};
